import { render, staticRenderFns } from "./ColumnsOrder.vue?vue&type=template&id=1a4a8944"
import script from "./ColumnsOrder.vue?vue&type=script&lang=js"
export * from "./ColumnsOrder.vue?vue&type=script&lang=js"
import style0 from "./ColumnsOrder.vue?vue&type=style&index=0&id=1a4a8944&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports